import { createContext } from 'react'

export const VariantSelectionContext = createContext({ parentSelected: false })
